/* global ADL */
/* global dataLayer */
import Vue from 'vue';

export default {
  defaultSet: false,
  defaultStatement: {
    actor: {
      objectType: 'Agent',
    },
    context: {
      instructor: {
        objectType: 'Agent',
      },
    }
  },
  setStatementDefaults(options) {
    this.defaultStatement.actor.name = options.actor.name.trim();
    this.defaultStatement.actor.mbox = `mailto:${options.actor.email.trim()}`;
    this.defaultStatement.context.instructor.name = options.instructor.name.trim();
    this.defaultStatement.context.instructor.mbox = `mailto:${options.instructor.email.trim()}`;
    this.defaultStatement.context.team = {
      name: 'Metadata',
      objectType: 'Group',
      member: [
        {
          name: options.actor.name.trim(),
          mbox: `mailto:${options.actor.email.trim()}`,
          objectType: 'Agent'
        },
        {
          name: options.instructor.name.trim(),
          mbox: `mailto:${options.instructor.email.trim()}`,
          objectType: 'Agent'
        },
        {
          name: options.school.name,
          mbox: `mailto:org+${options.school.id}@playposit.org`,
          objectType: 'Agent'
        },
        {
          name: options.lesson.title,
          mbox: `mailto:bulb+${options.lesson.id}@playposit.org`,
          objectType: 'Agent'
        }
      ]
    }
    this.defaultSet = true;
  },
  buildBeginLessonStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/start', 'started'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildSubmitQuestionStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/submit', 'submitted'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.question_id}`)
    );
    statement.context = this.defaultStatement.context;
    statement.result = options.result;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildReplayVideoStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/replay', 'replayed'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildRetakeQuestionStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/retake', 'retook'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.question_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildPlayVideoStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/play', 'played'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildPauseVideoStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/pause', 'paused'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildSeekVideoStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/seek', 'seeked'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.seek_time}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildExportLessonStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/export', 'exported'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildCompleteBulbStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/complete', 'completed'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildCompleteLessonStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/complete', 'completed'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildResetLessonStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/reset', 'reset'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.lesson_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildPostDiscussionCommentStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/post', 'posted'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.discussion_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildReplyDiscussionCommentStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/reply', 'replied'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.discussion_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  buildEditDiscussionCommentStatement(options, sendAfter = true) {
    if (!this.defaultSet) return;
    var statement = new ADL.XAPIStatement(
      this.defaultStatement.actor,
      new ADL.XAPIStatement.Verb('https://xapi.playposit.com/verbs/edit', 'edited'),
      new ADL.XAPIStatement.Activity(options.activity.id, options.activity.name, `${options.activity.discussion_id}`)
    );
    statement.context = this.defaultStatement.context;
    if (!sendAfter) return statement;
    return this.sendStatement(statement);
  },
  handleGoogleAnalytics(statement) {
    if (['submitted'].includes(statement.verb.display['en-US'])) {
      dataLayer.manualLog(statement.result.response, 'LOG');
    } else if (['retaken'].includes(statement.verb.display['en-US'])) {
      dataLayer.manualLog(`${statement.actor.name} ${statement.verb.display['en-US']} a question with a type of ${statement.object.definition.name['en-US']} and an ID of ${statement.object.definition.description['en-US']}.`, 'LOG');
    } else if (['posted', 'replied', 'edited'].includes(statement.verb.display['en-US'])) {
      dataLayer.manualLog(`${statement.actor.name} has ${statement.verb.display['en-US']} (${statement.object.definition.name['en-US']}) inside a discussion (${statement.object.definition.description['en-US']}).`, 'LOG');
    }else {
      dataLayer.manualLog(`${statement.actor.name} has ${statement.verb.display['en-US']} ${statement.object.definition.name['en-US']} (${statement.object.definition.description['en-US']}).`, 'LOG');
    }
  },
  sendStatement(statement) {
    if (!this.defaultSet) return;
    return new Promise((resolve, reject) => {
      // console.log('SENDING XAPI STATEMENT', statement);
      this.handleGoogleAnalytics(statement);
      ADL.XAPIWrapper.sendStatement(statement, (response, data) => {
        if (response.status !== 200) {
          dataLayer.errorLog(response);
          reject(response);
        }
        else {
          resolve(data);
        }
      });
    });
  },
  searchStatements(moreUrl, cb) {
    if (!this.defaultSet) return;
    return new Promise((resolve, reject) => {
      // return ADL.XAPIWrapper.getStatements({ limit: 20 }, moreUrl, cb);
      var search = ADL.XAPIWrapper.searchParams();
      search['agent'] = `{"mbox":"mailto:teacher@red.com"}`;
      search['related_agents'] = "true";
      resolve(ADL.XAPIWrapper.getStatements(search));
    });
  }
}
